/**
 * @flow
 * @relayHash 35ba0143d6553fe0245dbae88291341f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CatalogPartnerCardLoaderQueryVariables = {|
  documentId?: ?string
|};
export type CatalogPartnerCardLoaderQueryResponse = {|
  +viewer: ?{|
    +userId: ?number,
    +user: ?{|
      +mailAddress: ?string
    |},
    +cloudPartnerCatalog: ?{|
      +documentId: ?string,
      +available: ?boolean,
      +status: ?number,
    |},
  |}
|};
export type CatalogPartnerCardLoaderQuery = {|
  variables: CatalogPartnerCardLoaderQueryVariables,
  response: CatalogPartnerCardLoaderQueryResponse,
|};
*/


/*
query CatalogPartnerCardLoaderQuery(
  $documentId: String
) {
  viewer {
    userId
    user {
      mailAddress
      id
    }
    cloudPartnerCatalog(documentId: $documentId) {
      documentId
      available
      status
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "documentId",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "userId",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mailAddress",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "cloudPartnerCatalog",
  "storageKey": null,
  "args": [
    {
      "kind": "Variable",
      "name": "documentId",
      "variableName": "documentId"
    }
  ],
  "concreteType": "CloudPartnerCatalogType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "documentId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "available",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CatalogPartnerCardLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CatalogPartnerCardLoaderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ]
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CatalogPartnerCardLoaderQuery",
    "id": null,
    "text": "query CatalogPartnerCardLoaderQuery(\n  $documentId: String\n) {\n  viewer {\n    userId\n    user {\n      mailAddress\n      id\n    }\n    cloudPartnerCatalog(documentId: $documentId) {\n      documentId\n      available\n      status\n    }\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '801ab4fdee7b5a612dd4e17c9161b40f';
module.exports = node;
